import { binaryQuestionsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher];

const binaryQuestionRouteMetadata: IRouteMetadataObj<
  typeof binaryQuestionsRoutesObj
> = {
  create: {
    title: "binaryQuestion.create.title",
    description: "binaryQuestion.create.description",
    lazy: () => import("@/pages/questions/binary/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "binaryQuestion.edit.title",
    description: "binaryQuestion.edit.description",
    lazy: () => import("@/pages/questions/binary/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "binaryQuestion.view.title",
    description: "binaryQuestion.view.description",
    lazy: () => import("@/pages/questions/binary/form/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
};

export const binaryQuestionsRoutes = createRoute<
  typeof binaryQuestionsRoutesObj
>(binaryQuestionsRoutesObj, binaryQuestionRouteMetadata);
